import tippy from 'tippy.js';

let pricingButtons = document.querySelectorAll('.plan-button');

pricingButtons.forEach((button) => {
  button.addEventListener('click', () => {
    let platformTableContainer = button.closest('.plan-comparison');
    let pricingTableContainer = platformTableContainer.querySelector('.pricing-table-container');

    let activeButton = button.closest('.plan-toggle-buttons').querySelector('.plan-button.active');
    let oldPlanName = activeButton.dataset.planName;

    activeButton.classList.remove('active');
    button.classList.add('active');

    pricingTableContainer.classList.remove(oldPlanName);
    pricingTableContainer.classList.add(button.dataset.planName);
  });
});

let tippyElements = document.querySelectorAll('.column-title.with-tooltip');

tippyElements.forEach((tippyElement) => {
  let tippyButton = tippyElement.querySelector('.column-title-with-tooltip');
  let tippyTemplate = tippyElement.querySelector('.title-tooltip');

  tippy(tippyButton, {
    content: tippyTemplate.innerHTML,
    interactive: true,
    theme: 'light'
  });
});
